import { ENV } from '../../config/runtimeEnv';

import { ClinicDocument } from "../../types/file/ClinicDocumentTypes";
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_FILE_SERVER;

export const getClinicDocuments = async (): Promise<ClinicDocument[]> => {
    const response = await http.get(`${API_BASE_URL}/clinic-documents`);
    return response.data;
};

export interface UploadClinicDocumentInput {
    name: string;
    description?: string;
    category?: string;
    userId?: UserUuid;
    file: File;
}

export const uploadClinicDocument = async (input: UploadClinicDocumentInput): Promise<ClinicDocument> => {
    const formData = new FormData();
    formData.append("name", input.name);
    if (input.description) formData.append("description", input.description);
    if (input.category) formData.append("category", input.category);
    if (input.userId !== undefined) formData.append("user_id", input.userId.toString());
    formData.append("file", input.file);

    const response = await http.post(`${API_BASE_URL}/clinic-documents`, formData);
    return response.data;
};

export const downloadClinicDocument = async (fileId: string, fileName: string): Promise<void> => {
    const response = await http.post(
        `${API_BASE_URL}/clinic-documents/download`,
        { file_id: fileId },
        {
            responseType: "blob",
        }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const deleteClinicDocument = async (fileId: string): Promise<void> => {
    await http.delete(`${API_BASE_URL}/clinic-documents`, {
        data: { file_id: fileId },
    });
};
